
import { Watch,Mixins,Component,Ref,InjectReactive } from "vue-property-decorator";
import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";

import UploadImg from "@/components/uploadImg.vue";

import ETable from "@/components/ETable.vue";

import { Form } from "element-ui/types";

import { bookServiceList,bookServiceEdit } from "@/api/booking";

import { cloneDeep } from "lodash";

import { IServiceConfigQueryForm,IServiceConfigRecord } from "@/types/booking";
import { BookingRuntimeTypeEnum } from "@/enum/booking.enum";

import { StatusOptionsEnum } from "@/enum/common.enum";

import { ERuntimeType } from "@/enum/booking.enum";

@Component({
    components: {
        ETable,
        UploadImg
    }
})
export default class ServiceConfig extends Mixins(TablePagination,Resize) {
    @InjectReactive() currentTab!: string | number;
    @InjectReactive() merchantId!: string | number;
    @Ref("editFormRef") readonly EditFormRef!: Form;

    StatusOptionsEnum = StatusOptionsEnum;
    BookingRuntimeTypeEnum = BookingRuntimeTypeEnum;

    tabListSurplusHeight = 80;

    queryForm: IServiceConfigQueryForm = {
        deviceClassId: "",
        name: "",
    }

    deviceClassOptions = [];

    tableData: Array<IServiceConfigRecord> = [];

    loading = false;

    btnLoading = false;

    editRowInfo: IServiceConfigRecord = {
        id: "",
        deviceClassName: "",
        name: "",
        imgUrl: [],
        remark: "",
        runtime: undefined,
        status: true,
        runtimeType: 2,
    };

    rules = {
        name: [{ required: true,message: "请输入服务显示名称",trigger: "blur" }],
        imgUrl: [{ required: true,type: "array",message: "请上传封面",trigger: "blur" }],
        runtime: [{ required: true,message: "请输入服务时长",trigger: "blur" }],
        runtimeType: [{ required: true,message: "请选择预约时间间隔",trigger: "change" }],
    };

    ysbColumns = [
        { label: "服务显示名称",prop: "name" },
        { label: "设备分类",prop: "deviceClassName" },
        { label: "封面",prop: "imgUrl",align: "center",width: 130 },
        { label: "操作人",prop: "modifiedBy" },
        { label: "最后操作时间",prop: "modifiedTime" },
        { label: "操作",prop: "action",align: "center",width: 120 },
    ];

    merchantColumns = [
        { label: "服务显示名称", prop: "name" },
        { label: "封面",prop: "imgUrl",align: "center",width: 130 },
        { label: "服务时长",prop: "runtime",align: "center",width: 130 },
        { label: "预约时间间隔（分钟）", align: "center",width: 170, formatter: (row) => this.getRuntimeTypeDesc(row.runtimeType) },
        { label: "服务状态", prop: "",align: "center", width: 130, formatter: (row) => row.status ? "启用" : "禁用" },
        { label: "操作人",prop: "modifiedBy" },
        { label: "最后操作时间",prop: "modifiedTime" },
        { label: "操作",prop: "action",align: "center",width: 120 },
    ]

    get columns() {
        return this.merchantId ? this.merchantColumns : this.ysbColumns;
    }

    dialogVisible = false;

    get getDialogTitle() {
        if (this.merchantId) return this.editRowInfo.id ? "编辑服务" : "新增服务";
        return "编辑"
    }

    getRuntimeTypeDesc(runtimeType: ERuntimeType | null) {
        if (runtimeType == 1) return '30分钟';
        if (runtimeType == 2) return '1小时';
        return "";
    }

    mounted() {
        this.windowResize();
    }

    handleSearch() {
        this.resetCurrent()
        this.bookServiceList();
    }

    handleSwitchChange(newStatus,row) {
        row.status = !row.status;
        bookServiceEdit({
            ...row,
            merchantId: this.merchantId || 0,
            status: Number(newStatus),
        }).then(() => {
            this.bookServiceList();
        })
    }

    handleAddMerchantService() {
        this.editRowInfo = {
            id: "",
            deviceClassName: "",
            name: "",
            imgUrl: [],
            remark: "",
            runtime: undefined,
            status: true,
            runtimeType: 2,
        };
        this.dialogVisible = true;
    }

    bookServiceList() {
        this.loading = true;
        bookServiceList({ merchantId: this.merchantId || 0, ...this.queryForm, pageNum: this.currentPage,
            pageSize: this.pageSize, }).then((res) => {
            this.tableData = res.data.list || [];
            this.tableData.forEach(item => {
                item.status = Boolean(item.status);
            })
            this.itemTotal = res.data.total;
        }).finally(() => {
            this.loading = false;
        })
    }

    editRow(row: IServiceConfigRecord) {
        this.editRowInfo = cloneDeep(row);
        this.dialogVisible = true;
        this.editRowInfo.imgUrl = row.imgUrl ? [{ url: row.imgUrl }] : []
        this.editRowInfo.status = Boolean(this.editRowInfo.status);
    }

    confirm() {
        this.EditFormRef.validate().then(() => {
            const imgUrl = this.editRowInfo?.imgUrl[0]?.url || "";
            this.btnLoading = true;
            const api = bookServiceEdit;
            api({ ...this.editRowInfo,id: this.editRowInfo.id || undefined,merchantId: this.merchantId,status: Number(this.editRowInfo.status),imgUrl }).then((res) => {
                this.bookServiceList();
                this.handleClose();
            }).finally(() => {
                this.btnLoading = false;
            })
        })
    }

    cancel() {
        this.handleClose();
    }

    handleClose() {
        this.EditFormRef.resetFields();
        this.editRowInfo.imgUrl = [];
        this.dialogVisible = false;
    }

    @Watch("currentTab",{ immediate: true })
    getData() {
        if (this.currentTab != 3) return;
        this.bookServiceList();
    }
}
